export default __webpack_public_path__ + "static/media/TheScarf_03.22ee5301.png";